import { Configurations } from "../redux/reducers/configurations/configurations.reducer"

export const isSmartphoneSaleAllowed = (configurations?: Configurations): boolean => {
    return configurations?.smartphoneSale?.isAllowed ?? false
}

export const isTransactionalCreditAllowed = (configurations?: Configurations): boolean => {
    return (configurations?.transactionalCredit?.isAllowed ?? false) &&
        !isSmartphoneSaleAllowed(configurations)
}

export const isServiceCentralAllowed = (configurations?: Configurations): boolean => { 
    return !isSmartphoneSaleAllowed(configurations)
}